import { useTranslation } from "react-i18next";
import React, { useEffect, useState, useCallback } from 'react';
import { PopUp } from "components/common";
import { getDocumentBlob } from "services/users";
import './style.scss';

interface Props {
    documentId?: number | number[];
    documentMeta?: any;
    openViewModal: boolean;
    multiply?: boolean;
    closeModal: () => void;
}

export const ViewDocumentModal: React.FC<Props> = ({ documentId, documentMeta, openViewModal, multiply = false, closeModal }) => {

    const [fileType, setFileType] = useState<string | string[] | null>(null);
    const [fileData, setFileData] = useState<any>(null);
    const [files, setFiles] = useState<any[]>([]);
    const [fileTypes, setFileTypes] = useState<any[]>([]);
    const [images, setImages] = useState<string[]>([]);
    const { t } = useTranslation();

    console.log(documentId);

    const getDocumentForPreview = useCallback(() => {
        if (documentId) {
            if(Array.isArray(documentId)) {
                documentId.forEach(id => {
                    getDocumentBlob(id).then((res) => {
                        setFileTypes((prev) => [...prev, res.headers["content-type"]]);
                        setFiles((prev: any[]) => [...prev, res.data]);
                    });
                })
            } else {
                getDocumentBlob(documentId).then((res) => {
                    setFileType(res.headers["content-type"]);
                    setFileData(res.data);
                });
            }
        }
    }, [documentId]);

    useEffect(() => {
        if (openViewModal) {
            getDocumentForPreview();
        }

    }, [openViewModal, getDocumentForPreview]);

    const getMultiplyFilePreview = useCallback(() => {
        if(fileTypes && files && Array.isArray(files) && Array.isArray(fileTypes)) {
            let images: string[] = [];
            // @ts-ignore
            document.getElementById('pdf-viewer').classList.add('d-none');
            files.forEach((file) => {
                let url = URL.createObjectURL(file);
                images.push(url);
            })
            setImages(images)
        }
    }, [fileTypes, files]);

    const getFilePreview = useCallback(() => {
        if (fileType && fileData) {
            if (fileType.includes('image')) {
                let url = URL.createObjectURL(fileData);

                // @ts-ignore
                document.getElementById('pdf-viewer').classList.add('d-none');
                let img = document.getElementById('document-image');
                // @ts-ignore
                img.src = url;
            }

            if (fileType.includes('pdf')) {
                const file = new Blob([fileData], { type: 'application/pdf' });
                // @ts-ignore
                document.getElementById('pdf-viewer').src = URL.createObjectURL(file);
                // @ts-ignore
                document.getElementById('pdf-viewer').style.display = 'block';
            }
        }
    }, [fileData, fileType]);

    useEffect(() => {
        if (!multiply && fileData) {
            getFilePreview();
        }
    }, [fileData, getFilePreview, multiply]);

    useEffect(() => {
        if (multiply && files.length) {
            getMultiplyFilePreview();
        }
    }, [files, getMultiplyFilePreview, multiply]);

    const onCloseModal = () => {
        // @ts-ignore
        document.getElementById('pdf-viewer').removeAttribute('src');
        // @ts-ignore
        document.getElementById('pdf-viewer').classList.add('d-none');
        // @ts-ignore
        document.getElementById('document-image').removeAttribute('src');
        closeModal();
        setFiles([]);
        setFileTypes([]);
        setImages([]);
    };

    return (
        <div id={"view-document-modal"}>
            <button type="button" id={"view-document-btn"} className="d-none" data-bs-toggle="modal" data-bs-target="#viewDocumentModal" />
            <div className="modal fade" id="viewDocumentModal" data-bs-backdrop="static"
                tabIndex={-1} aria-labelledby="viewDocumentModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content" style={{ paddingBottom: 27 }}>
                        {/* <PopUp type="View Document" onClose={() => { */}
                        <PopUp type={t("view_document_type")} onClose={() => {
                            onCloseModal();
                            //@ts-ignore
                            document.getElementById("view-document-btn-close").click()
                        }}>
                            {Array.isArray(documentMeta) ? (
                                <dl className="view-modal-meta">
                                    {documentMeta.map(item => (<><dt>{item.title}</dt><dd>{item.value}</dd></>))}
                                </dl>
                            ) : null}
                            <div className={`view-modal-content ${images.length && 'multiply'}`}>
                                {!multiply && <img className={"img-fluid"} alt="" id="document-image" />}
                                {multiply && images.length && images.map(url => (
                                    <img className={"img-fluid"} key={url} src={url} alt="" id="document-image" />
                                ))}
                                <iframe id="pdf-viewer" title="pdf" style={{ width: '100%', height: 700 }} />
                            </div>
                        </PopUp>
                        <button type="button" id={"view-document-btn-close"} className="d-none" data-bs-dismiss="modal" />
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ViewDocumentModal;
